import { render, staticRenderFns } from "./Presencias.vue?vue&type=template&id=2c41fd89&"
import script from "./Presencias.vue?vue&type=script&lang=js&"
export * from "./Presencias.vue?vue&type=script&lang=js&"
import style0 from "./Presencias.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports